<template>
  <div id="app">
    <iframe
      src="https://www.seoul.go.kr"
      :scrolling="resetView ? `no`: `auto`"
      id="iframe"
      ref="iframe"
    />

    <div class="dim" v-if="resetView"></div>
    <div href="#" class="fab" @click="reset"></div>
    <div v-show="resetView" class="modal">
      <div class="modal-header">
        <div>
          <h3>봇다리</h3>
          <p>서울시 인공지능 챗봇</p>
        </div>
        <div class="btn-wrap">
          <div @click="refresh" class="refresh" />
          <div @click="reset" class="reset">✕</div>
        </div>
      </div>
      <Chatting style="background-color:rgb(255,255,255)" />
    </div>
  </div>
</template>

<script>
import Chatting from "./Chatting.vue";

export default {
  name: "App",
  watch: {
    resetView(n) {
      if (n) {
        this.scrollBottom();
      }
    }
  },
  components: {
    Chatting
  },
  data() {
    return {
      resetView: false
    };
  },
  mounted() {
    window.addEventListener("resize", this.scrollBottom);
  },
  methods: {
    scrollBottom() {
      this.$nextTick(() => {
        var div = document.getElementById("chatArea");
        div.scrollTop = div.scrollHeight;
      });
    },
    reset() {
      this.resetView = !this.resetView;
    },
    refresh() {
      if (confirm("모든 내역이 삭제됩니다.")) {
        this.$children[0].messages = [];
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../scss/index.scss";
</style>
